export default {
  TERMS_REQUEST: 'TERMS_REQUEST',
  TERMS_SUCCESS: 'TERMS_SUCCESS',
  TERMS_FAILURE: 'TERMS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/TermsConstants.js